/* eslint-disable */
import { withStyles } from '@material-ui/core/styles';
import cn from 'classnames';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import Page from '../../Components/Page/Page.component';
import withServices from '../../Contexts/Services/WithServices.context';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import './Settings.page.i18n';
import SettingsPagePropTypes from './Settings.page.props';
import SettingsPageSidebar from './Settings.page.sidebar';
import settingsPageStyles from './Settings.page.styles';

/**
 * SettingsPageComponent
 * @export
 * @class SettingsPageComponent
 * @extends {React.Component<SettingsPageComponentComposedProps, SettingsPageComponentState>}
 */
export class SettingsPageComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. **NOT** a `null` value
   * @static
   * @type {Partial<SettingsPageComponentProps>}
   * @memberof SettingsPageComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`SettingsPage`}
   * @memberof SettingsPageComponent
   */
  static displayName = `SettingsPage`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof SettingsPageComponent
   */
  static propTypes = SettingsPagePropTypes;

  /**
   * Data specific to the `<SettingsPage />` instance
   * @type {SettingsPageComponentState}
   * @memberof SettingsPageComponent
   */
  state = {};

  /**
   * Render the component
   * @returns {React.Component} The rendered `<SettingsPage />`
   * @memberof SettingsPageComponent
   */
  render() {
    const { classes } = this.props;
    return <Page className={cn(classes.root)} heading="SettingsPage.PageHeading" sidebarContent={<SettingsPageSidebar />} title="SettingsPage.PageTitle" />;
  }
}

/** @type {React.ComponentClass<SettingsPageComponentProps>} */
const SettingsPage = compose(
  withRouter,
  withServices,
  withStyles(themeCreateInjectableStyles(settingsPageStyles), { withTheme: true }),
)(SettingsPageComponent);

export default SettingsPage;
